<script lang="ts">
	import { Button, Container, Modal, Text } from '@Shelly/shelly-design-system/index';
	import { createEventDispatcher } from 'svelte';
	import type { CameraZone } from '../../types/camera-zones';

	import { format } from 'svelte-i18n';

	export let showModal = false;
	export let zone_settings: CameraZone;
	export let zone_id: number;
	export let isLoading: boolean = false;

	const dispatch = createEventDispatcher();
</script>

<Modal
	{showModal}
	on:close={() => dispatch('close')}
	title={$format('button_delete', { default: 'Delete' })}
	><svelte:fragment slot="content">
		<Container padding="0">
			<Text class="mb-s">
				{$format('on_delete_msg', {
					default: 'Are you sure you want to delete {this_type}?',
					values: {
						this_type:
							zone_settings?.name || $format('label_this_zone', { default: 'this zone' }),
					},
				})}
			</Text>
		</Container>
	</svelte:fragment>
	<div class="d-flex justify-content-end" slot="footer">
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			variant="secondary"
			on:click={() => dispatch('close')}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			variant="danger"
			responsiveSize={{
				sm: 'm',
			}}
			loading={isLoading}
			disabled={isLoading}
			on:click={() => dispatch('delete', { zone_id })}
		>
			{$format('button_delete', { default: 'Delete' })}
		</Button>
	</div>
</Modal>
